// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oc-avatar img {
  margin-right: 1.25em;
}
.oc-avatarName {
  font-size: 1.375em;
  line-height: 1.5em;
  color: #000;
}`, "",{"version":3,"sources":["webpack://./src/components/avatar/Avatar.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".oc-avatar img {\n  margin-right: 1.25em;\n}\n.oc-avatarName {\n  font-size: 1.375em;\n  line-height: 1.5em;\n  color: #000;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
